/**
 * Русская плюрализация — ОТДЕЛЬНЫЙ модуль без зависимостей.
 *
 * Не в ru-grammar.ts намеренно: тот тянет petrovich на верхнем уровне, а plural
 * нужен браузерным чанкам панели, где petrovich — лишний вес (П20, бюджет
 * бандла; sideEffects у пакета не объявлен — tree-shaking его не спасёт).
 * ru-grammar реэкспортирует plural — грамматический API остаётся единым (П9).
 */
/**
 * Форма слова под число. Три формы, как в языке, а не две — самодельные
 * тернарники по сервисам давали «10 звёздочки», «2 звёздочек», «21 вариантов».
 *
 *   plural(1,  'звёздочка', 'звёздочки', 'звёздочек') → 'звёздочка'
 *   plural(3,  …) → 'звёздочки'   plural(10, …) → 'звёздочек'
 *   plural(21, …) → 'звёздочка'   plural(112, …) → 'звёздочек'
 *
 * Работает и для окончаний: plural(n, 'е', 'я', 'й') → «сообщени…».
 * Дробные («2.50 звёздочки») — форма few, отрицательные — по модулю.
 * Арифметика ручная, не Intl.PluralRules: панель живёт в браузере, сервисы в
 * Node — форма не должна зависеть от ICU-сборки среды.
 */
export function plural(n, one, few, many) {
    const a = Math.abs(n);
    if (!Number.isInteger(a))
        return few;
    const d100 = a % 100;
    if (d100 >= 11 && d100 <= 14)
        return many;
    const d10 = a % 10;
    if (d10 === 1)
        return one;
    if (d10 >= 2 && d10 <= 4)
        return few;
    return many;
}
//# sourceMappingURL=plural.js.map